import { useMemo } from 'react';
import type { ColumnType } from 'xui-pro';
import type { Definition } from '@/api/sip/bookmap/circuitInfoUsingPOST';
import { useTranslation } from '@/hooks/useTranslation';

const useColumns = definitionColumnList => {
  const $ = useTranslation();

  const columns = useMemo(() => {
    return [
      {
        title: $('编码'),
        dataIndex: 'pcode'
      },
      {
        title: $('定义'),
        dataIndex: 'definition'
      },
      {
        title: $('线色'),
        dataIndex: 'wireColor',
        hidden: !definitionColumnList?.includes('wireColor')
      },
      {
        title: $('信号类型'),
        dataIndex: 'signalType',
        hidden: !definitionColumnList?.includes('signalType')
      },
      {
        title: $('测量参考值'),
        dataIndex: 'measureReferenceValue',
        hidden: !definitionColumnList?.includes('measureReferenceValue')
      },
      {
        title: $('备注'),
        dataIndex: 'remark'
      }
    ] as ColumnType<Definition>[];
  }, [$, definitionColumnList]);
  return columns;
};

export { useColumns };
